<div *ngIf="item" [style.background-position]="'bottom'" [style.background-repeat]="'no-repeat'" [style.background-image]="'url(' + item.overlayImage + ')'" class="carousel-item {{item.backgroundColor ?? 'default'}}">
  <div class="title">{{ item.title }}</div>
  <div class="description">{{ item.description }}</div>
  <div class="image-section"><img [src]="item.backgroundImage" /></div>
  <div class="action">
    <button (click)="itemClicked.emit(item.id)" class="{{ item.buttonType ?? 'default' }}">{{item.buttonText}}</button>
  </div>
</div>
